import { RootState } from '../types';

export function isAdBarOpen(state: RootState): boolean {
    return state.adBar.open;
}
